/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Buildname1Inputs */

const id_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Build`)
};

const ms_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Binaan`)
};

const da_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build navn`)
};

const de_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-Name`)
};

const en_us2_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Name`)
};

const es_es2_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de compilación`)
};

const es_mx2_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de compilación`)
};

const fil_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan ng Build`)
};

const fr_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de compilation`)
};

const it_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome build`)
};

const hu_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build neve`)
};

const nl_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buildnaam`)
};

const no_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-navn`)
};

const pl_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa kompilacji`)
};

const pt_br2_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da build`)
};

const pt_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da compilação`)
};

const ro_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nume compilare`)
};

const fi_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversion nimi`)
};

const sv_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggnamn`)
};

const vi_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên bản dựng`)
};

const tr_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı Adı`)
};

const cs_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název sestavení`)
};

const bg_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Име на компилация`)
};

const ru_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя сборки`)
};

const uk_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва збірки`)
};

const ar_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم البنية`)
};

const hi_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड नाम`)
};

const th_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อบิลด์`)
};

const ja_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド名`)
};

const zh_cn2_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建名称`)
};

const zh_hant1_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置名稱`)
};

const ko_builds_table_buildname1 = /** @type {(inputs: Builds_Table_Buildname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드 이름`)
};

/**
* | output |
* | --- |
* | "Build Name" |
*
* @param {Builds_Table_Buildname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_buildname1 = /** @type {((inputs?: Builds_Table_Buildname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Buildname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_buildname1(inputs)
	if (locale === "ms") return ms_builds_table_buildname1(inputs)
	if (locale === "da") return da_builds_table_buildname1(inputs)
	if (locale === "de") return de_builds_table_buildname1(inputs)
	if (locale === "en-US") return en_us2_builds_table_buildname1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_buildname1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_buildname1(inputs)
	if (locale === "fil") return fil_builds_table_buildname1(inputs)
	if (locale === "fr") return fr_builds_table_buildname1(inputs)
	if (locale === "it") return it_builds_table_buildname1(inputs)
	if (locale === "hu") return hu_builds_table_buildname1(inputs)
	if (locale === "nl") return nl_builds_table_buildname1(inputs)
	if (locale === "no") return no_builds_table_buildname1(inputs)
	if (locale === "pl") return pl_builds_table_buildname1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_buildname1(inputs)
	if (locale === "pt") return pt_builds_table_buildname1(inputs)
	if (locale === "ro") return ro_builds_table_buildname1(inputs)
	if (locale === "fi") return fi_builds_table_buildname1(inputs)
	if (locale === "sv") return sv_builds_table_buildname1(inputs)
	if (locale === "vi") return vi_builds_table_buildname1(inputs)
	if (locale === "tr") return tr_builds_table_buildname1(inputs)
	if (locale === "cs") return cs_builds_table_buildname1(inputs)
	if (locale === "bg") return bg_builds_table_buildname1(inputs)
	if (locale === "ru") return ru_builds_table_buildname1(inputs)
	if (locale === "uk") return uk_builds_table_buildname1(inputs)
	if (locale === "ar") return ar_builds_table_buildname1(inputs)
	if (locale === "hi") return hi_builds_table_buildname1(inputs)
	if (locale === "th") return th_builds_table_buildname1(inputs)
	if (locale === "ja") return ja_builds_table_buildname1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_buildname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_buildname1(inputs)
	return ko_builds_table_buildname1(inputs)
});
export { builds_table_buildname1 as "builds.table.buildName" }